import CommandHub from "../locales/de/CommandHub.json";
import CreateUser from "../locales/de/CreateUser.json";
import Navigation from "../locales/de/Navigation.json";
import ServiceTracker from "../locales/de/ServiceTracker.json";
import translation from "../locales/de/translation.json";
import {
  bankingTranslations,
  documentTranslations,
} from "@/modules/integrations";

const translations = {
  translation,
  ServiceTracker,
  Navigation,
  CommandHub,
  CreateUser,
  Banking: bankingTranslations.de,
  Documents: documentTranslations.de,
};
export default translations;
